import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // for navigation
import Select from 'react-select';
import 'react-quill/dist/quill.snow.css'; // Import the Quill editor's styles
import ReactQuill from "react-quill";
import { useLocation } from "react-router-dom";
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import moment from 'moment-timezone';
import Loader from 'layouts/nbn/components/loader';

const SERVER_URL = process.env.REACT_APP_API_URL;

function RaiseWorkPlanDeviationList() {
    const [planDetails, setPlanDetails] = useState([{ date: '', day: '', plan: '' }]);
    const [selectedWeek, setSelectedWeek] = useState({ start: '', end: '' });
    const [weekDays, setWeekDays] = useState([]);
    const [selectedDay, setSelectedDay] = useState("");  // To store the selected day
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [reviewers, setReviewers] = useState(null);  // Default to null to check if data exists
    const [setLoad, setLoading ] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();  // For navigation


    const handleWeekChange = (e) => {
       
        const weekRange = JSON.parse(e.target.value);
        setSelectedWeek(weekRange);

        const startDate = new Date(weekRange.start);
        const days = [];

        // Generate weekdays based on the selected start of the week
        for (let i = 0; i < 5; i++) {
            const day = new Date(startDate);
            day.setDate(startDate.getDate() + i);
            days.push({
                value: day.toISOString().split('T')[0],
                label: day.toLocaleString('default', { weekday: 'long' })
            });
        }

        setWeekDays(days); // Set weekdays for the dropdown
    };

    const getWeekOptions = () => {
        const options = [];
        const currentDate = new Date();

        const currentDay = currentDate.getDay();
        const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay;
        currentDate.setDate(currentDate.getDate() + daysUntilMonday);

        for (let i = 0; i < 4; i++) {
            const startOfWeek = new Date(currentDate);
            startOfWeek.setDate(currentDate.getDate() + i * 7);

            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 4);

            const weekLabel = `${startOfWeek.toLocaleString('default', { month: 'short' })} ${startOfWeek.getDate()} - ${endOfWeek.toLocaleString('default', { month: 'short' })} ${endOfWeek.getDate()}`;
            const weekRange = { start: startOfWeek.toISOString().split('T')[0], end: endOfWeek.toISOString().split('T')[0] };
            options.push(<option key={i} value={JSON.stringify(weekRange)}>{weekLabel}</option>);
        }

        return options;
    };

    const handleDayChange = async (selectedOption) => {
        setLoading(true);
        // Set the selected day (assuming selectedOption has the date in 'value')
        setSelectedDay(selectedOption);
        
        // Extract the date from selectedOption (assuming it's in a valid format)
        const selectedDate = selectedOption.value;
        
        // Now, make the API request with the selected date
        const headers = await getApiHeader(); // Ensure getApiHeader() returns the right headers
        
        try {
            // Make the API request to fetch the work plan for the selected date
            const response = await axios.post(
                `${SERVER_URL}work-plan/get-one-day-work-plan-for-deviation-request`,
                {
                    date: selectedDate, // Pass the selected date
                },
                {
                    headers: headers,
                }
            );
    
            console.log('Response Data:', response.data.data);
    
            const workPlan = response.data.data.work_plan_data.work_plan;
            const workPlanData = response.data.data.work_plan_data;
    
            const reviewers_data = {
                retailer_id: workPlanData.retailer_id,
                work_status: workPlan.status,
                retailercode: workPlanData.retailer_code,
                retailername: workPlanData.retailer_name,
                workPlanId: workPlan.work_plan_id
            };
    
            console.log('Reviewers:', reviewers_data);
    
            setReviewers(reviewers_data); // Set the reviewers data if present
        
        } catch (error) {
            // Log the error if the API request fails
            console.error("Error fetching work plan data:", error);
            setReviewers(null); // Clear reviewers if there's an error
        } finally {
            // Stop loading indicator after request finishes
            setLoading(false);
        }
    };

    const handleActionClick = (retailer_id,workPlanId) => {
        console.log('aa',retailer_id,workPlanId);
        // Navigate to the next component, passing PID data as state
        navigate(`/edit_raise_work_plan_deviationlist`, { state: { retailer_id,workPlanId } });
    };

    useEffect(() => {
        if (location.state) {
            const weekValue = {
                start: "2024-10-28",
                end: "2024-11-01"
            };

            handleWeekChange({ target: { value: JSON.stringify(weekValue) } });
        } else {
            console.log('No selected PID Data available.');
        }
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div className="container">
                <form className="workplanform col-lg-12">
                    <div className="flex-container">
                        {location.state ? (
                            <div className="work-details">
                                <h4>{location.state.reviewer.name} Work Details</h4> <br></br>
                            </div>
                        ) : (
                            <div className="work-plan">
                                <h4>Raise Work Plan deviation request</h4>
                                <label htmlFor="work-week" className="label">Select the Work Week:</label>
                                <select id="work-week" name="work-week" className="select" onChange={handleWeekChange}>
                                    <option value="">Please choose an option</option>
                                    {getWeekOptions()}
                                </select>
                            </div>
                        )}

                        <div className="work-day-selection"> <br></br>
                            <label htmlFor="work-day" className="label">Select a Day:</label>
                            <Select
                                id="work-day"
                                options={weekDays}
                                value={selectedDay}
                                onChange={handleDayChange}
                                placeholder="Select a day"
                            />
                        </div>
                    </div>

                    <p>These details are for Viewing Editing and Approving Plan Details</p>

                       {setLoad ? (
                        <div className="text-center">
                            <Loader />  {/* You can replace this with a spinner component */}
                        </div>
                        ) : (

                    <div className="table-responsive mt-3">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Sl No</th>
                                    <th>Retailer Code</th>
                                    <th>Retailer Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reviewers ? (
                                    <tr key={reviewers.retailer_id}>
                                        <td>{1}</td>
                                        <td>{reviewers.retailercode}</td>
                                        <td>{reviewers.retailername}</td>
                                        <td>
                                            {reviewers.work_status === 1 ? 'Approved' :
                                            reviewers.work_status === 2 ? 'Rejected' : 
                                            'Pending'}
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-danger btn-sm ms-2"
                                                onClick={() => handleActionClick(reviewers.retailer_id,reviewers.workPlanId)} // Pass retailer_id
                                            >
                                                View Plans Details
                                            </button>
                                        </td>
                                    </tr>
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: 'center' }}>
                                        No Work plan deviations found for the selected date.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
        )}
                </form>
            </div>
        </DashboardLayout>
    );
}

export default RaiseWorkPlanDeviationList;
